module.exports = __webpack_public_path__ + "cy.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/cy.svg
// module id = 766
// module chunks = 0